import script from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"

import "@/views/auth/SignUpView.css?vue&type=style&index=0&id=ca33b962&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca33b962"]])

export default __exports__